import { useNavigation } from '@react-navigation/native';
import { PatientStackParamList } from '@/navigations/PatientStack';
import { logError } from '@/utils/logHandling';
import type { StackNavigationProp } from '@react-navigation/stack';
import { localLogoutUser } from '@/api/services/user';
import { getAccessToken, serverLogoutUser } from '@/stores/auth/services';
import ConfirmModal from '../SharedComponents/ConfirmModal/ConfirmModal';
import { usePatientDemo } from '@/contexts/PatientDemoContext';
import { IS_WEB } from '@/utils/platform';

export function DemoModal() {
  const {
    showDemoPopUp,
    setShowDemoPopUp,
    logoutFromDemo,
    popupDelayMs,
    popupTimerRef,
    setLogoutFromDemo,
  } = usePatientDemo();
  const { navigate } =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  const demoWebLogout = () => {
    if (IS_WEB) {
      const url = new URL(window.location.href);
      url.searchParams.delete('demoStarten');
      window.history.replaceState(null, '', url.toString());
    }
  };

  const confirmAction = async () => {
    demoWebLogout();
    clearTimeout(popupTimerRef.current!);
    setLogoutFromDemo(false);
    setShowDemoPopUp(false);
    await serverLogoutUser({ jwt: (await getAccessToken()) as string });
    await localLogoutUser();
    navigate('SignUpController');
  };

  const cancelAction = async () => {
    if (logoutFromDemo) {
      try {
        demoWebLogout();
        clearTimeout(popupTimerRef.current!);
        setLogoutFromDemo(false);
        setShowDemoPopUp(false);
        await serverLogoutUser({ jwt: (await getAccessToken()) as string });
        await localLogoutUser();
      } catch (err) {
        logError('Error with patient demo:', err);
        await localLogoutUser();
      }
    } else {
      setShowDemoPopUp(false);
      setTimeout(() => {
        setShowDemoPopUp(true);
      }, popupDelayMs);
    }
  };

  return (
    <ConfirmModal
      verticalAlignButtons={true}
      isVisible={showDemoPopUp}
      contentText="Gefällt Ihnen neolexon? Dann testen Sie unsere App 14 Tage kostenlos mit individuell für Sie eingestellten Wörtern und Sätzen!"
      headerText="Danke für das Ausprobieren der Demo!"
      confirmText="Jetzt zur Testphase anmelden"
      cancelText={logoutFromDemo ? 'Demo beenden' : 'weiter testen'}
      confirmAction={confirmAction}
      cancelAction={cancelAction}
    />
  );
}
